import { TimeFrame } from '../../../../../filters/enum/TimeFrame';

export const socketRoutePath = '/TodaysPriceChange';
export const socketAvailableTimeFrames = [TimeFrame.YTD, TimeFrame.Quarter, TimeFrame.Month, TimeFrame.Year];
